import { makeAutoObservable } from 'mobx';
import def from './def';
import goods from './goods';
import mGoods from './m_goods';
import { default as mediaOk, default as mediaVk } from './media';
import modules from './module';
import payment from './payment';
import pickup from './pickup';
import priceMod from './price_mod';
import userEmp from './user_emp';
import vCmp from './v_cmp';

class Data {
	s = {
		def,
		goods,
		mGoods,
		mediaVk,
		mediaOk,
		userEmp,
		pickup,
		priceMod,
		modules,
		payment,
		vCmp
	};
	constructor(props) {
		makeAutoObservable(this);
	}
}

const data = new Data();
export default data;
